import { useMemo } from 'react'

import {
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  CheckOutlined
} from '@ant-design/icons'

import { ProDropdown } from '@eastcoal/common/components/ProDropdown'
import { pick } from '@eastcoal/common/utils/object'

import { DropdownButton } from '../../../DropdownButton'
import { useImageCardStore } from '../../Store/hooks/useStore'
import { TextAlign } from '../../Store/store/interface'

const items = [
  {
    key: 'left',
    icon: <AlignLeftOutlined />,
    label: '左对齐'
  },
  {
    key: 'center',
    icon: <AlignCenterOutlined />,
    label: '居中对齐'
  },
  {
    key: 'right',
    icon: <AlignRightOutlined />,
    label: '右对齐'
  }
]

export const AlignDropdown = () => {
  const { align, setAlign, getPopupContainer } = useImageCardStore(state =>
    pick(state, ['align', 'setAlign', 'getPopupContainer'])
  )

  const selectedKeys = useMemo(() => (align ? [align] : undefined), [align])

  return (
    <ProDropdown
      arrow={false}
      getPopupContainer={getPopupContainer}
      placement='bottomLeft'
      selectedIcon={<CheckOutlined />}
      trigger={['click']}
      menu={{
        items,
        selectedKeys,
        onClick({ key }) {
          setAlign(key as TextAlign)
        }
      }}
    >
      <DropdownButton tooltip='对齐方式'>
        <AlignLeftOutlined />
      </DropdownButton>
    </ProDropdown>
  )
}
